"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddEmailForm", {
  enumerable: true,
  get: function get() {
    return _Form.AddEmailForm;
  }
});
Object.defineProperty(exports, "AddPhoneNumberForm", {
  enumerable: true,
  get: function get() {
    return _Form.AddPhoneNumberForm;
  }
});
Object.defineProperty(exports, "AddedSuccess", {
  enumerable: true,
  get: function get() {
    return _Success.AddedSuccess;
  }
});
Object.defineProperty(exports, "CodeVerifyForm", {
  enumerable: true,
  get: function get() {
    return _CodeVerifyForm["default"];
  }
});
Object.defineProperty(exports, "RecoveryMethodDetail", {
  enumerable: true,
  get: function get() {
    return _Detail["default"];
  }
});
Object.defineProperty(exports, "RemoveRecoveryMethod", {
  enumerable: true,
  get: function get() {
    return _Remove["default"];
  }
});
Object.defineProperty(exports, "RemovedSuccess", {
  enumerable: true,
  get: function get() {
    return _Success.RemovedSuccess;
  }
});
Object.defineProperty(exports, "UpdateEmailForm", {
  enumerable: true,
  get: function get() {
    return _Form.UpdateEmailForm;
  }
});
Object.defineProperty(exports, "UpdatePhoneNumberForm", {
  enumerable: true,
  get: function get() {
    return _Form.UpdatePhoneNumberForm;
  }
});
Object.defineProperty(exports, "UpdatedSuccess", {
  enumerable: true,
  get: function get() {
    return _Success.UpdatedSuccess;
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactAlbus = require("react-albus");
var _Detail = _interopRequireDefault(require("./Detail"));
var _Remove = _interopRequireDefault(require("./Remove"));
var _CodeVerifyForm = _interopRequireDefault(require("./CodeVerifyForm"));
var _Form = require("./Form");
var _Success = require("./Success");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Wrapper = (0, _reactAlbus.withWizard)(function (_ref) {
  var wizard = _ref.wizard,
    initialStep = _ref.initialStep,
    children = _ref.children;
  (0, _react.useEffect)(function () {
    if (initialStep) {
      wizard.replace(initialStep);
    }
  }, [initialStep]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex",
    style: {
      minHeight: 400
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, children));
});
var View = function View(_ref2) {
  var initialStep = _ref2.initialStep,
    steps = _ref2.steps;
  return /*#__PURE__*/_react["default"].createElement(_reactAlbus.Wizard, {
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        initialStep: initialStep
      }, /*#__PURE__*/_react["default"].createElement(_reactAlbus.Steps, null, steps.map(function (_ref3) {
        var id = _ref3.id,
          render = _ref3.render;
        return /*#__PURE__*/_react["default"].createElement(_reactAlbus.Step, {
          key: id,
          id: id,
          render: render
        });
      })));
    }
  });
};
var _default = exports["default"] = View;
//# sourceMappingURL=index.js.map